export enum ReportType {
  Schicht = "Schicht",
  Wohnung = "Wohnung",
  Verlaufsdokumentation = "Verlaufsdokumentation",
}
